// extracted by mini-css-extract-plugin
module.exports = {"alert":"style_alert__2rw9w","success":"style_success__3X1xg","error":"style_error__1aIry"};